import { createContext } from "react";

const CustomerContext = createContext(null);

export default CustomerContext;
